import type { SVGProps } from 'react';
import * as React from 'react';

const SvgAlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="currentColor"
    height="100%"
    viewBox="0 0 16 16"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8 .833a7.167 7.167 0 1 1 0 14.335A7.167 7.167 0 0 1 8 .833M8 10.4a.6.6 0 1 0 0 1.2h.008a.6.6 0 1 0 0-1.2zm0-6a.6.6 0 0 0-.6.6v3a.6.6 0 1 0 1.2 0V5a.6.6 0 0 0-.6-.6"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgAlertCircle;
